'use client';
import { jsx } from 'react/jsx-runtime';
import t from 'tiny-warning';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { TabsContext } from './tabs.context.js';
import { useDidImmutableValueChange } from '../../hooks/use-did-immutable-value-change.js';
import { useMap } from '../../hooks/use-map.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { useControllableValue } from '../../hooks/use-controllable-value.js';
import { useId } from '../../hooks/use-id.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, t) {
    if (null == e) return {};
    var o, r, a = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], !(t.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(e, o) && (a[o] = e[o]);
    }
    return a;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var o, r, a = {}, n = Object.keys(e);
    for(r = 0; r < n.length; r++)o = n[r], t.indexOf(o) >= 0 || (a[o] = e[o]);
    return a;
}
const Tabs = renderWithRef('Tabs', null, (r, u)=>{
    useDeprecatedProps('Tabs', r, [
        {
            propName: 'wrapHeaders',
            instructions: 'Use the default scrolling behaviour of Tabs instead.'
        }
    ]), useComponentStylesLoaded('Tabs', SWAN_STYLE_KEY_MAP.tabs);
    let { children: b, centerHeaders: f = false, stickyHeaders: h = false, wrapHeaders: m = false, showDividingLine: w = true, defaultSelectedTabId: T, selectedTabId: y, onRequestTabChange: v } = r, _ = _object_without_properties(r, [
        "children",
        "centerHeaders",
        "stickyHeaders",
        "wrapHeaders",
        "showDividingLine",
        "defaultSelectedTabId",
        "selectedTabId",
        "onRequestTabChange"
    ]), g = new Set([
        'swan-vanilla-ignore',
        'swan-tabs'
    ]);
    f && g.add('swan-tabs-center-headers'), h && g.add('swan-tabs-sticky-headers'), m && g.add('swan-tabs-wrap-headers'), false === w && g.add('swan-tabs-no-dividing-line');
    let I = void 0 !== y;
    t(!useDidImmutableValueChange(I), I ? 'The `Tabs` component switched from "Uncontrolled" to "Controlled". This is an unsupported pattern. This can happen if `selectedTabId` was not initially defined, but was defined in a subsequent render' : 'The `Tabs` component switched from "Controlled" to "Uncontrolled". This is an unsupported pattern. This can happen if `selectedTabId` was initially defined, but not defined in a subsequent render. If you\'re trying to make it so that _no_ tab is selected, you should pass `null` for `selectedTabId`'), t(I || void 0 !== T, '`defaultSelectedTabId` is required if `selectedTabId` is not provided. If you really want there to be _no_ tab selected initially, pass `null` for `defaultSelectedTabId`');
    let [j, { set: O, remove: k }] = useMap(), [C, { set: q, remove: x }] = useMap(), [S, { set: H, remove: R }] = useMap(), [P, U] = useControllableValue({
        value: y,
        onChange: v || void 0,
        defaultValue: null != T ? T : null,
        defaultOnChange: (e, ...t)=>{
            let [o] = t;
            e(o);
        }
    }), N = useId();
    return jsx(TabsContext.Provider, {
        value: {
            tabsName: N,
            selectedTabId: P,
            onRequestTabChange: U,
            headerIds: j,
            registerHeader: O,
            unregisterHeader: k,
            labelIds: C,
            registerLabel: q,
            unregisterLabel: x,
            contentIds: S,
            registerContent: H,
            unregisterContent: R
        },
        children: jsx(RenderComp, {
            root: "div",
            forwardedRef: u,
            classNames: g,
            props: _,
            children: b
        })
    });
});

export { Tabs };
